import { CredentialsTypes } from '@ply-io/ply-front-shared-utilities';

export const EMBEDDED_CONNECTION_ID = 'EMBEDDED_CONNECTION';
export const PER_USER_CONNECTION_ID = 'PERSONAL_CONNECTION';
export const PER_ACCOUNT_CONNECTION_ID = 'GENERAL_CONNECTION';

export const VIRTUAL_PROFILES_IDS = [PER_USER_CONNECTION_ID, PER_ACCOUNT_CONNECTION_ID];

export const PROFILE_FROM_CONFIGURATION_CREDENTIALS_TYPES = [CredentialsTypes.ProfileBased, CredentialsTypes.AccountBased];
